import React, { useState, useRef, useEffect, useCallback } from 'react';
import { TagBox } from 'devextreme-react/tag-box';
import { DateBox } from 'devextreme-react/date-box';
import { SelectBox } from 'devextreme-react/select-box';
import 'devextreme-react/text-area';
import { groupBy } from '../../utils/miscUtil';
import Form, {
  SimpleItem, Item, GroupItem, TabbedItem, TabPanelOptions, Tab,
  Label, RequiredRule, RangeRule, StringLengthRule, ButtonItem, EmptyItem,
} from 'devextreme-react/form';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import {iogpValues, yesnoValues, causalValues, sifStatusValues} from '../../api/api'



var disciplines = require('../../api/DiscipineTree.json');
disciplines = groupBy(disciplines, 'Discipline')
var disciplinesList = [];
Object.keys(disciplines).forEach((value, index) => disciplinesList.push({value:value}));
disciplinesList = disciplinesList.sort((a,b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0))

var categories = require('../../api/CategoryTree.json');
categories = groupBy(categories, 'Category')
var categoriesList = [];
Object.keys(categories).forEach((value, index) => categoriesList.push({value:value}));
categoriesList = categoriesList.sort((a,b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0))

const GroupCaption = ({ iconName, caption }) => (
  <React.Fragment>
    <i className={`${iconName} me-2`}></i>
    <span>{caption}</span>
  </React.Fragment>
);

const renderCategoryCaption = (data) => (
  <GroupCaption iconName="fas fa-layer-group" {...data} />
);
const renderToolsCaption = (data) => (
  <GroupCaption iconName="fas fa-tools" {...data} />
);
const renderListCaption = (data) => (
  <GroupCaption iconName="fas fa-list" {...data} />
);


export default function SIFEventClass(props) {
  const [conditionOptions, setConditionOptions] = useState({});
  const [activityOptions, setActivityOptions] = useState({});
  const [subactivityOptions, setSubactivityOptions] = useState({});
  const [sifEvent, setSifEvent] = useState({});
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const onActivitySelected = useCallback((e, actL) => {
    if (!e.value) {
      setSifEvent(prev => {
        if (!prev || prev['Activity Subgroup or Task'] === null) return prev;
        return { ...prev, 'Activity Subgroup or Task': null };
      });
      setSubactivityOptions({
        dataSource: [],
        activeStateEnabled: true,
        valueExpr: 'value',
        displayExpr: 'value',
        searchEnabled: true,
      });
      return;
    }
    var act = actL ? actL[e.value] : null;
    if (!act) return;
    act = groupBy(act, 'Subactivity');
    var activitiesList = [];
    Object.keys(act).forEach((value) => activitiesList.push({value: value}));
    activitiesList = activitiesList.sort((a,b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0));
    setSubactivityOptions({
      dataSource: activitiesList,
      activeStateEnabled: true,
      valueExpr: 'value',
      displayExpr: 'value',
      searchEnabled: true,
    });
  }, []);

  const onDisciplineSelected = useCallback((e) => {
    if (!e.value) {
      setSifEvent(prev => {
        if (!prev || (prev['Activity at Time of Event'] === null && prev['Activity Subgroup or Task'] === null)) return prev;
        return { ...prev, 'Activity at Time of Event': null, 'Activity Subgroup or Task': null };
      });
      setActivityOptions({
        dataSource: [],
        activeStateEnabled: true,
        valueExpr: 'value',
        displayExpr: 'value',
        searchEnabled: true,
      });
      return;
    }
    var act = disciplines[e.value];
    if (!act) return;
    act = groupBy(act, 'Activity');
    var activitiesList = [];
    Object.keys(act).forEach((value) => activitiesList.push({value: value}));
    activitiesList = activitiesList.sort((a,b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0));
    setActivityOptions({
      dataSource: activitiesList,
      activeStateEnabled: true,
      valueExpr: 'value',
      displayExpr: 'value',
      searchEnabled: true,
      onValueChanged: (ev) => { onActivitySelected(ev, act); },
    });
  }, [onActivitySelected]);

  const onCategorySelected = useCallback((e) => {
    if (!e.value) {
      setSifEvent(prev => {
        if (!prev || prev['SIF Condition'] === null) return prev;
        return { ...prev, 'SIF Condition': null };
      });
      setConditionOptions({
        dataSource: [],
        activeStateEnabled: true,
        valueExpr: 'Condition',
        displayExpr: 'Condition',
        searchEnabled: true,
      });
      return;
    }
    setConditionOptions({
      dataSource: categories[e.value] || [],
      activeStateEnabled: true,
      valueExpr: 'Condition',
      displayExpr: 'Condition',
      searchEnabled: true,
    });
  }, []);

  useEffect(() => {
    if (!props.data) {
      return;
    }
    setSifEvent(props.data);
    if (props.data["SIF CATEGORY"]) {
      onCategorySelected({ value: props.data["SIF CATEGORY"] });
    }
    if (props.data["Discipline of Activity at Time of Event"]) {
      onDisciplineSelected({ value: props.data["Discipline of Activity at Time of Event"] });
    }
    if (props.data["Activity at Time of Event"] && props.data["Discipline of Activity at Time of Event"]) {
      var act = disciplines[props.data["Discipline of Activity at Time of Event"]];
      if (act) {
        act = groupBy(act, 'Activity');
        onActivitySelected({ value: props.data["Activity at Time of Event"] }, act);
      }
    }
  }, [props.data, onCategorySelected, onDisciplineSelected, onActivitySelected]);

  useEffect(() => {
    let keys = Object.keys(props.aiLoading || {});
    var working = false;
    for (var i = 0; i < keys.length; i++) {
      if (props.aiLoading[keys[i]]) {
        working = true;
        break;
      }
    }
    setLoading(working);
  }, [props.aiLoading]);

  const onCTA = useCallback(() => {
    let v_data = formRef.current.instance().validate();
    if (v_data.isValid) {
      props.onCTA();
    }
    props.onValidData(v_data.isValid);
  }, [props]);

  const eventCategoryOptions = {
    dataSource: categoriesList,
    activeStateEnabled: true,
    valueExpr: 'value',
    displayExpr: 'value',
    searchEnabled: true,
    onValueChanged: onCategorySelected,
    disabled: loading,
    placeholder: loading ? "Loading AI suggestion..." : null,
  };

  const disciplineOptions = {
    dataSource: disciplinesList,
    activeStateEnabled: true,
    valueExpr: 'value',
    displayExpr: 'value',
    searchEnabled: true,
    onValueChanged: onDisciplineSelected,
    disabled: loading,
    placeholder: loading ? "Loading AI suggestion..." : null,
  };

  const iogpOptions = {
    dataSource: iogpValues,
    activeStateEnabled: true,
    valueExpr: 'value',
    displayExpr: 'value',
    searchEnabled: true,
    disabled: loading,
    placeholder: loading ? "Loading AI suggestion..." : null,
  };

  const ynuOptions = {
    dataSource: yesnoValues,
    activeStateEnabled: true,
    valueExpr: 'value',
    displayExpr: 'value',
    searchEnabled: true,
    disabled: loading,
  };

  const causalOptions = {
    dataSource: causalValues,
    activeStateEnabled: true,
    valueExpr: 'value',
    displayExpr: 'value',
    searchEnabled: true,
    disabled: loading,
  };

  const statusOptions = {
    dataSource: sifStatusValues,
    activeStateEnabled: true,
    valueExpr: 'value',
    displayExpr: 'value',
    searchEnabled: true,
    disabled: loading,
  };

  const ctaButtonOptions = {
    text: 'Save',
    type: 'default',
    onClick: onCTA,
    width: '120px',
    disabled: loading,
  };

  const cancelButtonOptions = {
    text: 'Cancel',
    type: 'default',
    stylingMode: 'outlined',
    onClick: () => { props.onCancel(); },
    width: '120px',
    disabled: loading,
  };

  return (
    <div>

        <Form
        ref={formRef}
        colCount={2}
        formData={sifEvent}
        onFieldDataChanged={(e) => {
          setSifEvent(e.component.option("formData"));
          props.onDataChanged(e.component.option("formData"));
        }}
      >
        <GroupItem>
        <GroupItem captionRender={renderCategoryCaption} caption="Category">
          <Item dataField="SIF CATEGORY" editorType="dxSelectBox" editorOptions={eventCategoryOptions}>
            <Label text="Category"/>
            <RequiredRule message="Category is required" />
          </Item>
          <Item dataField="SIF Condition" editorType="dxSelectBox" editorOptions={{ ...conditionOptions, disabled: loading, placeholder: loading ? "Loading AI suggestion..." : null }}>
            <Label text="Condition"/>
          </Item>
          <Item dataField="IOGP Life-Saving Rule Violation" editorType="dxSelectBox" editorOptions={iogpOptions}>
            <Label text="Which IOGP Life-Saving Rule did the incident violate"/>
          </Item>
        </GroupItem>

        <GroupItem captionRender={renderToolsCaption} caption="Discipline & Activity">
          <Item dataField="Discipline of Activity at Time of Event" editorType="dxSelectBox" editorOptions={disciplineOptions}>
            <Label text="Discipline of Activity at Time of Event"/>
          </Item>
          <Item dataField="Activity at Time of Event" editorType="dxSelectBox" editorOptions={{ ...activityOptions, disabled: loading, placeholder: loading ? "Loading AI suggestion..." : null }}>
            <Label text="Activity at Time of Event"/>
          </Item>
          <Item dataField="Activity Subgroup or Task" editorType="dxSelectBox" editorOptions={{ ...subactivityOptions, disabled: loading, placeholder: loading ? "Loading AI suggestion..." : null }}>
            <Label text="Activity Subgroup or Task"/>
          </Item>

        </GroupItem>
        </GroupItem>
        <GroupItem>
          <GroupItem captionRender={renderListCaption} caption="Other">
            <Item dataField="Was it reasonable that a person was or could have been in proximity at the time of the event?" editorType="dxSelectBox" editorOptions={ynuOptions}>
              <Label text="Was it reasonable that a person was or could have been in proximity at the time of the event?"/>
            </Item>
            <Item dataField="Did a barrier/control prevent or mitigate the event from becoming an Actual SIF?" editorType="dxSelectBox" editorOptions={ynuOptions}>
              <Label text="Did a barrier/control prevent or mitigate the event from becoming an Actual SIF?"/>
            </Item>
            <Item dataField="Primary Causal Factors" editorType="dxSelectBox" editorOptions={causalOptions}>
              <Label text="Primary Causal Factors"/>
            </Item>
            <Item dataField="Cause Description" editorType="dxTextArea">
              <Label text="Cause Description"/>
            </Item>
            <Item dataField="What is the status of the Causal Investigation?" editorType="dxSelectBox" editorOptions={statusOptions}>
              <Label text="What is the status of the Causal Investigation?"/>
            </Item>
          </GroupItem>
          <GroupItem colCount={1} cssClass="buttons-group-2">
            <EmptyItem></EmptyItem>
            <GroupItem
              cssClass="d-flex flex-row justify-content-end"
              colCount={2}
            >
              <ButtonItem
                buttonOptions={cancelButtonOptions}
                name="Cancel"
              />
              <ButtonItem buttonOptions={ctaButtonOptions} />
            </GroupItem>
          </GroupItem>
        </GroupItem>
      </Form>

    </div>
  );
}
